import React from 'react';
import { testimonios } from '../data/oferta';
export function TestimoniosSection() {
  const [primero, segundo, destacado] = testimonios;
  return <section aria-labelledby="testimonios-titulo" className="border-b border-violet-line/40 bg-violet" data-id="element-115" data-mp="32hyba43ozmhx">
      <div className="mx-auto max-w-5xl px-6 py-20 sm:py-24 lg:px-8" data-id="element-116" data-mp="2ti2y5tqkthf9">
        <h2 id="testimonios-titulo" className="font-serif text-3xl font-medium leading-tight text-bone sm:text-4xl" data-id="element-117" data-mp="2tg8cgd7hdla4">
          Lo que dicen quienes ya lo hicieron
        </h2>

        <div className="mt-12 grid gap-8 lg:grid-cols-[1fr_1fr]" data-id="element-118" data-mp="2jlzweozmzksu">
          <figure className="flex h-full flex-col border border-gold/30 bg-violet-deep p-8 lg:row-span-2 lg:p-10" data-id="element-119" data-mp="25tjsllywviqv">
            <blockquote className="font-serif text-2xl font-light italic leading-snug text-bone sm:text-[1.75rem]" data-id="element-120" data-mp="2as3a9a6h28df">
              “{destacado.quote}”
            </blockquote>
            <figcaption className="mt-auto pt-8" data-id="element-121" data-mp="20scg59ltpvdv">
              <p className="font-sans text-sm font-medium text-gold" data-id="element-122" data-mp="20v8dowtrei1s">
                {destacado.nombre}
              </p>
              <p className="mt-1 font-sans text-xs font-light tracking-wide text-bone/50" data-id="element-123" data-mp="lum9qyu8tdud">
                {destacado.detalle}
              </p>
            </figcaption>
          </figure>

          {[primero, segundo].map(t => <figure key={t.nombre} className="flex h-full flex-col border-l border-violet-line pl-6 lg:pl-8" data-id="element-124" data-mp="vtv43st0suh9">
              <blockquote className="font-sans text-base font-light leading-relaxed text-bone/80" data-id="element-125" data-mp="33ux9oeyl7br">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-auto pt-5" data-id="element-126" data-mp="gwu9nhjg2lf3">
                <p className="font-sans text-sm font-medium text-bone" data-id="element-127" data-mp="c4t043dnv8sr">
                  {t.nombre}
                </p>
                <p className="mt-1 font-sans text-xs font-light tracking-wide text-bone/50" data-id="element-128" data-mp="3kjkthfdpc7bq">
                  {t.detalle}
                </p>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}